import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GridTileImage } from './tile';
import { getProducts } from 'lib/burokshop';
import type { Product } from 'lib/burokshop/types';
import { useMarketplace } from '../../context/MarketplaceContext';

function ThreeItemGridItem({
  item,
  size,
  priority
}: {
  item: Product;
  size: 'full' | 'half';
  priority?: boolean;
}) {
  return (
    <div
      className={size === 'full' ? 'md:col-span-4 md:row-span-2' : 'md:col-span-2 md:row-span-1'}
    >
      <Link
        className="relative block aspect-square h-full w-full"
        to={`/product/${item.handle}`}
      >
        <GridTileImage
          src={item.featuredImage.url}
          fill
          sizes={
            size === 'full' ? '(min-width: 768px) 66vw, 100vw' : '(min-width: 768px) 33vw, 100vw'
          }
          priority={priority}
          alt={item.title}
          label={{
            position: size === 'full' ? 'center' : 'bottom',
            title: item.title as string,
            amount: item.priceRange.maxVariantPrice.amount,
            currencyCode: item.priceRange.maxVariantPrice.currencyCode
          }}
        />
      </Link>
    </div>
  );
}

export function ThreeItemGrid() {
  const [homepageItems, setHomepageItems] = useState<Product[]>([]);
  const { marketplaceType } = useMarketplace();

  useEffect(() => {
    async function loadProducts() {
      try {
        const products = await getProducts({
    sortKey: 'UPDATED_AT',
          reverse: true,
          marketplaceType
  });
        setHomepageItems(products);
      } catch (error) {
        console.error('Error loading products:', error);
        setHomepageItems([]);
      }
    }
    loadProducts();
  }, [marketplaceType]);

  if (!homepageItems[0] || !homepageItems[1] || !homepageItems[2]) return null;

  const [firstProduct, secondProduct, thirdProduct] = homepageItems;

  return (
    <section className="mx-auto grid max-w-(--breakpoint-2xl) gap-4 px-4 pt-8 pb-4 md:grid-cols-6 md:grid-rows-2 lg:max-h-[calc(100vh-200px)]">
      <ThreeItemGridItem size="full" item={firstProduct} priority={true} />
      <ThreeItemGridItem size="half" item={secondProduct} priority={true} />
      <ThreeItemGridItem size="half" item={thirdProduct} />
    </section>
  );
}


